import { h } from 'preact'

interface Props {
    image: string
}

const DropdownImage = ({
    image
}: Props) => (
    <div class='dropdown-image'>
        <img src={image}/>
    </div>
)

export default DropdownImage
